<script lang="ts">
    import CN from "classnames";

    type Size =
        | "xxs"
        | "xs"
        | "sm"
        | "md"
        | "lg"
        | "xl"
        | "xm"
        | "xlg"
        | undefined;
    type Component = "p" | "span" | "h1" | "h2";

    export let theme: "" | "error" = "";
    export let variant: "primary" | "secondary" | "button" | "link" | "base" =
        "primary";
    export let compact = false;
    export let size: Size = undefined;
    export let weight: "normal" | "medium" | "semibold" = "normal";
    export let style: "normal" | "italic" = "normal";
    export let component: Component = "p";

    const calculateSize = (size: Size, component: Component): Size => {
        if (size) return size;

        if (component === "h1") return "xlg";
        if (component === "h2") return "lg";

        return "md";
    };
    $: calculatedSize = calculateSize(size, component);
</script>

<svelte:element
    this={component}
    class={CN("gw-layout-text", `gw-layout-text--variant-${variant}`, {
        "gw-error-theme": theme === "error",
    })}
    style={`
        --font-size: var(--gw-font-size-${calculatedSize});
        --line-height: calc(var(--font-size) * ${compact ? 1.2 : 1.5});
        --font-style: ${style};
        --font-weight: var(--gw-font-weight-${weight});
    `}
    {...$$restProps}
>
    <slot />
</svelte:element>

<style lang="postcss">
    .gw-layout-text {
        margin: 0;
        font-size: var(--font-size);
        line-height: var(--line-height);
        font-style: var(--font-style);
        font-weight: var(--font-weight);

        &--variant-base {
            font-size: inherit;
            color: inherit;
            font-weight: inherit;
            line-height: inherit;
        }

        &--variant-primary {
            color: var(--gw-dark-grey-text-primary-color);
        }

        &--variant-secondary {
            color: var(--gw-dark-grey-text-secondary-color);
        }

        &--variant-button {
            color: var(--gw-theme-accent-btn-text);
        }

        &--variant-link {
            color: var(--gw-theme-accent-link-text);
        }

        &.gw-error-theme {
            color: var(--gw-theme-accent-text-secondary);
        }
    }
</style>
